import { useSessionStore } from "@/stores/session"
import bus from '@/utils/event_bus'

const onlyAdminsGuard = function (to, from, next) {
    const session_store = useSessionStore()
    let auth = session_store.user_object.auth
    
    // Verificar si el usuario tiene rol de admin, es superusuario o tiene el flag as_admin
    const isAllowed = auth.role === "sys_admin" || auth.role === "company_admin" || auth.is_superuser || auth.as_admin;
    
    // Log to verify the guard operation
    console.log(`=== GUARD: onlyAdminsGuard ===`);
    console.log(`Route: ${to.path}`);
    console.log(`User role: ${auth.role}`);
    console.log(`Is superuser: ${auth.is_superuser}`);
    console.log(`Has as_admin flag: ${auth.as_admin}`);
    console.log(`Access allowed: ${isAllowed}`);
    console.log('========================');
    
    if (isAllowed) {
        next()
    } else {
        bus.emit('notification', { timeout: 3000, text: "You don't have permissions to enter this view. Contact your company admin.", color: "error" })
        next(false)
    }
}


const hasSessionObjectGuard = function (to, from, next) {
    const session_store = useSessionStore()
    if (session_store.user_object._flag == "not-initialized") {
        session_store.getUserObject()
            .then(() => {
                // LOAD THINGS HERE IF NEEDED
                next()
            })
    } else {
        next()
    }
}


const check_login_subroutine = function (to, next) {
    const session_store = useSessionStore()
    // Auth lock
    if (session_store.authenticated) {
        next()
    } else {
        console.log("here add prop redirect to the next route")
        next({ name: 'login', query: { redirect: to.path } })
    }
}

const isAuthenticated = function (to, from, next) {
    const session_store = useSessionStore()
    if (session_store.user_object._flag == "not-initialized") {
        // Get user
        console.log("[i] Initializing user object.")
        session_store.getUserObject()
            .then(() => {
                check_login_subroutine(to, next)
            })
    } else {
        check_login_subroutine(to, next)
    }


}


// Function to print guard information in the console
const logGuardInfo = (guardName, isAllowed, route) => {
    console.log(`=== GUARD: ${guardName} ===`);
    console.log(`Route: ${route.path}`);
    console.log(`Access allowed: ${isAllowed}`);
    console.log('========================');
};

// Guard to restrict access to external workshop users
const onlyWorkshopGuard = function (to, from, next) {
    const session_store = useSessionStore()
    
    // If the user is a workshop type or an internal user, allow access
    const isAllowed = session_store.is_external_workshop || !session_store.is_external_customer;
    
    // Log to verify the guard operation
    logGuardInfo('onlyWorkshopGuard', isAllowed, to);
    
    if (isAllowed) {
        next()
    } else {
        bus.emit('notification', { 
            timeout: 3000, 
            text: "This section is only for workshops. You don't have permission to access.", 
            color: "error" 
        })
        next(false)
    }
}

// Guard to restrict access to external customer users
const onlyCustomerGuard = function (to, from, next) {
    const session_store = useSessionStore()
    
    // If the user is a customer type or an internal user, allow access
    const isAllowed = session_store.is_external_customer || !session_store.is_external_workshop;
    
    // Log to verify the guard operation
    logGuardInfo('onlyCustomerGuard', isAllowed, to);
    
    if (isAllowed) {
        next()
    } else {
        bus.emit('notification', { 
            timeout: 3000, 
            text: "This section is only for customers. You don't have permission to access.", 
            color: "error" 
        })
        next(false)
    }
}

// Guard to restrict access to internal users
const onlyInternalUsersGuard = function (to, from, next) {
    const session_store = useSessionStore()
    
    // If the user is not external, allow access
    const isAllowed = !session_store.is_external_customer && !session_store.is_external_workshop;
    
    // Log to verify the guard operation
    logGuardInfo('onlyInternalUsersGuard', isAllowed, to);
    
    if (isAllowed) {
        next()
    } else {
        bus.emit('notification', { 
            timeout: 3000, 
            text: "This section is only for internal users. You don't have permission to access.", 
            color: "error" 
        })
        next(false)
    }
}

export {
    onlyAdminsGuard,
    hasSessionObjectGuard,
    isAuthenticated,
    onlyWorkshopGuard,
    onlyCustomerGuard,
    onlyInternalUsersGuard
}
